<template>

            <div style="padding-left: 30%; align-items: center;">
              <table class="row row-2" align="center" width="100%" border="0" cellpadding="0" cellspacing="0"
              role="presentation" style="  background-size: auto; align-items: center;">
              <tbody>
                <tr>
                  <td>
                    <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0"
                      role="presentation"
                      style="  background-color: #ffffff; background-size: auto; border-radius: 0; color: #000000; "
                      width="745">
                      <tbody>
                        <tr>
                          <td class="column column-1" width="100%"
                            style="  font-weight: 400; text-align: left; padding-bottom: 5px; padding-left: 40px; padding-right: 40px; padding-top: 5px; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;">
                           
                            <table class="image_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0"
                              role="presentation" style=" ">
                              <tr>
                                <td class="pad" style="width:50%;padding-right:0px;padding-left:0px;">
                                  <div class="alignment" align="center" style="line-height:10px">
                                    <div style="max-width: 166.25px;"><img
                                        src="https://5ed40aab9d.imgdist.com/pub/bfra/v5qme5w2/m1a/e4x/x2x/logo-13.png"
                                        style="display: block; height: auto; border: 0; width: 100%;" width="166.25"
                                        height="auto"></div>
                                  </div>
                                </td>
                                
                              </tr>
                            </table>
                            <table class="divider_block block-3" width="100%" border="0" cellpadding="10"
                              cellspacing="0" role="presentation" style=" ">
                              <tr>
                                <td class="pad">
                                  <div class="alignment" align="center">
                                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" width="95%"
                                      style=" ">
                                      <tr>
                                        <td class="divider_inner"
                                          style="font-size: 1px; line-height: 1px; border-top: 1px solid #848484;">
                                          <span>&#8202;</span>
                                        </td>
                                      </tr>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            </table>
                            <table class="heading_block block-4" width="100%" border="0" cellpadding="0" cellspacing="0"
                              role="presentation" style=" ">

                              <td class="pad"
                                style="padding-left:10px;padding-right:10px;text-align:center;width:100%;">
                                <br>
                                <h1
                                  style="margin: 0; color: #4d4d4d; direction: ltr; font-family: Arial, Helvetica, sans-serif; font-size: 24px; font-weight: 700; letter-spacing: normal; line-height: 120%; text-align: center; margin-top: 0; margin-bottom: 0;">
                                  📣 REALTORTOOLS FOR REALTORS: MORE THAN A PLATFORM, AN OPPORTUNITY.
                                </h1>
                                <br>
                                <span class="tinyMce-placeholder"><a href="https://www.realtortools.org/"
                                    target="_blank"
                                    style="text-decoration: none; color: #e1b33e; font-family: Arial, Helvetica, sans-serif;"
                                    rel="noopener"><span class="mce-content-body mce-edit-focus"
                                      style="position: relative;" id="8abd68a5-128b-419e-bc10-99024896301c"
                                      data-position="20-0-3" data-qa="tinyeditor-root-element"><span
                                        class="tinyMce-placeholder">www.realtortools.org</span></span></a></span>
                              </td>

                            </table>

                            <table class="paragraph_block block-6" width="100%" border="0" cellpadding="10"
                              cellspacing="0" role="presentation" style="  word-break: break-word;">
                              <tr>
                                <td class="pad">
                                  <div
                                    style="color:#6b6b6b;direction:ltr;font-family:Arial, Helvetica, sans-serif;font-size:15px;font-weight:400;letter-spacing:0px;line-height:140%;text-align:center">
                                    <p style="margin: 0;">As a Realtor, <em>you</em> are the lead
                                      generator, the driving force behind the real
                                      estate industry.
                                      Your mission and duty is to be productive—and
                                      today, there is a single tool that will
                                      revolutionize the real estate market by making
                                      Realtors more productive. <br><br>
                                      A unique tool for Realtors who want to go
                                      further, reaching national and international
                                      markets with residential and investment clients.
                                      Watch an overview of the personalized sub-system
                                      you can create on the RealtorTools platform 👉
                                      <a href="https://www.realtortools.org/scope"
                                        style="color: #e1b33e; text-decoration: none;">https://www.realtortools.org/scope</a>
                                    </p>

                                  </div>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="row row-3" align="center" width="100%" border="0" cellpadding="0" cellspacing="0"
              role="presentation" style=" ">
              <tbody>
                <tr>
                  <td>
                    <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0"
                      role="presentation"
                      style="  background-color: #ffffff; border-radius: 0; color: #000000; width: 745px; margin: 0 auto;"
                      width="745">
                      <tbody>
                        <tr>
                          <td class="column column-1" width="100%"
                            style="  font-weight: 400; text-align: left; padding-bottom: 5px; padding-top: 5px; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;">
                            <div class="spacer_block block-1" style="height:20px;line-height:20px;font-size:1px;">
                              &#8202;
                            </div>
                            <table class="heading_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0"
                              role="presentation" style=" ">
                              <tr>
                                <td class="pad"
                                  style="padding-left:60px;padding-right:60px;padding-top:10px;text-align:center;width:100%;">
                                  <h1
                                    style="margin: 0; color: #4d4d4d; direction: ltr; font-family: Arial, Helvetica, sans-serif; font-size: 22px; font-weight: 700; letter-spacing: normal; line-height: 120%; text-align: center; margin-top: 0; margin-bottom: 0;  ">
                                    🏆 What do you get by creating your own sub-system?
                                  </h1>
                                </td>
                              </tr>
                            </table>
                            <table class="divider_block block-3" width="100%" border="0" cellpadding="10"
                              cellspacing="0" role="presentation" style=" ">
                              <tr>
                                <td class="pad">
                                  <div class="alignment" align="center">
                                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" width="35%"
                                      style=" ">
                                      <tr>
                                        <td class="divider_inner"
                                          style="font-size: 1px; line-height: 1px; border-top: 1px solid #848484;">
                                          <span>&#8202;</span>
                                        </td>
                                      </tr>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Benefits Section -->
            <table class="row row-4" align="center" width="100%" border="0" cellpadding="0" cellspacing="0"
              role="presentation" style=" ">
              <tbody>
                <tr>
                  <td>
                    <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0"
                      role="presentation"
                      style="  background-color: #ffffff; border-radius: 0; color: #000000; width: 745px; margin: 0 auto;"
                      width="745">
                      <tbody>
                        <tr>
                          <td class="column column-1" width="100%"
                            style="  font-weight: 400; text-align: left; padding-bottom: 20px; padding-left: 40px; padding-right: 40px; padding-top: 20px; vertical-align: top;">

                            <table class="paragraph_block block-1" width="100%" border="0" cellpadding="10"
                              cellspacing="0" role="presentation" style="  word-break: break-word;">
                              <tr>
                                <td class="pad">
                                  <div
                                    style="color:#4d4d4d;direction:ltr;font-family:Arial, Helvetica, sans-serif;font-size:15px;font-weight:400;letter-spacing:0px;line-height:140%;text-align:left;">

                                    <div class="benefit-item">
                                      <span class="benefit-number">1.</span> 💡 <strong>High-value leads on
                                        autopilot</strong><br>
                                      Access 17 easy-to-use mathematical and financial applications designed to attract
                                      buyers—residential, national and international investors.
                                    </div>

                                    <div class="benefit-item">
                                      <span class="benefit-number">2.</span> 🌍 <strong>Reach beyond
                                        borders</strong><br>
                                      Generate leads at the local, state, and international levels directly from your
                                      sub-system.
                                    </div>

                                    <div class="benefit-item">
                                      <span class="benefit-number">3.</span> 🎯 <strong>Diversity in your client
                                        base</strong><br>
                                      From first-time homebuyers to global investors.
                                    </div>

                                    <div class="benefit-item">
                                      <span class="benefit-number">4.</span> 🎥 <strong>Marketing with real
                                        impact</strong><br>
                                      • Personalized videos with your own tools<br>
                                      • Virtual consultations (AnyDesk, TeamViewer) and in-person events<br>
                                      • Personalized events using your registered sub-system account
                                    </div>

                                    <div class="benefit-item">
                                      <span class="benefit-number">5.</span> 🤝 <strong>Integration with key
                                        professionals</strong><br>
                                      Your sub-system includes lenders, title companies, and local inspectors. Missing
                                      one? The platform will connect you—just request the Sub-system Code to include
                                      them in your registration 👉 <a href="https://www.realtortools.org/register/realtorcode"
                                        style="color: #e1b33e; text-decoration: none;">www.realtortools.org/register/realtorcode</a>
                                    </div>

                                    <div class="benefit-item">
                                      <span class="benefit-number">6.</span> 🔗 <strong>Nationwide Realtor
                                        connections</strong><br>
                                      Form alliances with agents across the country to expand your opportunities.
                                    </div>

                                    <div class="benefit-item">
                                      <span class="benefit-number">7.</span> 📁 <strong>Efficient client
                                        management</strong><br>
                                      Organize contacts by stage: closed, pending, or in process—all from your account.
                                    </div>

                                    <div class="benefit-item">
                                      <span class="benefit-number">8.</span> 🎓 <strong>Instant, easy-to-follow
                                        training</strong><br>
                                      Tutorial videos and key notes in every system application.
                                    </div>

                                    <div class="benefit-item">
                                      <span class="benefit-number">9.</span> ⚡ <strong>Fast and human
                                        support</strong><br>
                                      Have questions? Write to us—we'll respond quickly.
                                    </div>

                                    <div class="benefit-item">
                                      <span class="benefit-number">10.</span> 🔍 <strong>Client record
                                        archives</strong><br>
                                      Keep track of both your pending and closed clients, organized into residential and
                                      investor files.
                                    </div>

                                  </div>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Additional Information Section -->
            <table class="row row-5" align="center" width="100%" border="0" cellpadding="0" cellspacing="0"
              role="presentation" style=" ">
              <tbody>
                <tr>
                  <td>
                    <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0"
                      role="presentation"
                      style="  background-color: #f5f5f5; border-radius: 0; color: #000000; width: 745px; margin: 0 auto;"
                      width="745">
                      <tbody>
                        <tr>
                          <td class="column column-1" width="100%"
                            style="  font-weight: 400; text-align: left; padding-bottom: 30px; padding-left: 40px; padding-right: 40px; padding-top: 30px; vertical-align: top;">

                            <table class="paragraph_block block-1" width="100%" border="0" cellpadding="10"
                              cellspacing="0" role="presentation" style="  word-break: break-word;">
                              <tr>
                                <td class="pad">
                                  <div
                                    style="color:#4d4d4d;direction:ltr;font-family:Arial, Helvetica, sans-serif;font-size:15px;font-weight:400;letter-spacing:0px;line-height:140%;text-align:left;">
                                    <p style="margin: 0; margin-bottom: 20px;">
                                      Your sub-system usually includes: lenders, title companies, and inspectors. Ask
                                      your Broker if they already have a configuration code for a sub-system that
                                      includes their preferred team. If yes: use that code when registering. If not: you
                                      can request a code by clicking this link 👉 <a
                                        href="https://www.realtortools.org/register/realtorcode"
                                        style="color: #e1b33e; text-decoration: none;">www.realtortools.org/register/realtorcode</a>.
                                      You'll find lenders, title companies, and resources for building your custom
                                      applications.
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Call to Action Section -->
            <table class="row row-6" align="center" width="100%" border="0" cellpadding="0" cellspacing="0"
              role="presentation" style=" ">
              <tbody>
                <tr>
                  <td>
                    <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0"
                      role="presentation"
                      style="  background-color: #ffffff; border-radius: 0; color: #000000; width: 745px; margin: 0 auto;"
                      width="745">
                      <tbody>
                        <tr>
                          <td class="column column-1" width="100%"
                            style="  font-weight: 400; text-align: center; padding-bottom: 40px; padding-left: 40px; padding-right: 40px; padding-top: 40px; vertical-align: top;">

                            <table class="paragraph_block block-1" width="100%" border="0" cellpadding="10"
                              cellspacing="0" role="presentation" style="  word-break: break-word;">
                              <tr>
                                <td class="pad">
                                  <div
                                    style="color:#4d4d4d;direction:ltr;font-family:Arial, Helvetica, sans-serif;font-size:18px;font-weight:700;letter-spacing:0px;line-height:140%;text-align:center;">
                                    <p style="margin: 0; margin-bottom: 20px;">
                                      🎯Stop doing the same thing and expecting different results.
                                      Transform the way you work. Activate your sub-system on RealtorTools and start
                                      generating real income.
                                    </p>
                                    <div style="text-align: center; margin: 30px 0;">
                                      <a href="https://www.realtortools.org" class="cta-button"
                                        style="background-color: #e1b33e; color: white; padding: 15px 30px; text-decoration: none; border-radius: 5px; font-weight: bold; display: inline-block; margin: 20px 0;">
                                        🌐 Visit www.realtortools.org
                                      </a>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
         


</template>
<script setup lang="ts">
</script>
<style lang="scss">


.desktop_hide,
.desktop_hide table {
  display: none;
  max-height: 0px;
  overflow: hidden;
}

.image_block img+div {
  display: none;
}

@media (max-width:765px) {
  .desktop_hide table.icons-inner {
    display: inline-block !important;
  }

  .icons-inner {
    text-align: center;
  }

  .icons-inner td {
    margin: 0 auto;
  }

  .mobile_hide {
    display: none;
  }

  .row-content {
    width: 100% !important;
  }

  .stack .column {
    width: 100%;
    display: block;
  }

  .mobile_hide {
    min-height: 0;
    max-height: 0;
    max-width: 0;
    overflow: hidden;
    font-size: 0px;
  }

  .desktop_hide,
  .desktop_hide table {
    display: table !important;
    max-height: none !important;
  }
}

.golden-text {
  background: #b37a24;
  background: linear-gradient(127deg, #b37a24, #f1cc6c 60%, #b37a24 90%, #f0cb6b);
  -webkit-background-clip: text;
  background-clip: text;
  color: rgba(0, 0, 0, .2);
  font-weight: 900
}

.benefit-item {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f9f9f9;
  border-left: 4px solid #e1b33e;
  border-radius: 5px;
}

.benefit-number {
  color: #e1b33e;
  font-weight: bold;
  font-size: 16px;
}

.cta-button {
  background-color: #e1b33e;
  color: white;
  padding: 15px 30px;
  text-decoration: none;
  border-radius: 5px;
  font-weight: bold;
  display: inline-block;
  margin: 20px 0;
}

.cta-button:hover {
  background-color: #b37a24;
  color: white;
}
</style>